import { Navigate, useLocation, useParams } from 'react-router-dom'

/** Both the case root and old dashboard links open the overview, keeping the chosen date. */
export default function CaseLanding() {
  const { search } = useLocation()
  const { caseId } = useParams<{ caseId: string }>()
  return <Navigate to={{ pathname: `/cases/${caseId}/overview`, search }} replace />
}
